import api2 from './api-v2';
import config from '../../config';

const getAllUsers = async () => {
    const client = await api2.getClient();
    const response = await client.get(`${config.VUE_APP_NUCLEUS_API}/api/v1/users/admin/all`);
    return api2.handleSuccess(response);
};

const getUserById = async (id) => {
    const client = await api2.getClient();
    const response = await client.get(`${config.VUE_APP_NUCLEUS_API}/api/v1/users/admin/${id}`);
    return api2.handleSuccess(response);
};

const setScaleRole = async (id, role) => {
    const client = await api2.getClient();
    const response = await client.put(`${config.VUE_APP_NUCLEUS_API}/api/v1/users/admin/${id}/scaleRole`, { role });
    return api2.handleSuccess(response);
};

export default { getAllUsers, getUserById, setScaleRole };
